import { useMemo } from 'react';
export var useDeviceDetect = function () {
    var isMobile = useMemo(function () {
        var userAgent = '';
        if (typeof window !== 'undefined' &&
            typeof window.navigator !== 'undefined')
            userAgent = navigator.userAgent;
        return !!userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i);
    }, []);
    return { isMobile: isMobile };
};
